export default __webpack_public_path__ + "static/ds-theming-typography-6f85018ba919dd568ea846b854d2b621.png";